<template>
  <div class="basic_wrap choose-page">
    <div class="red_top_bg page-top">
      <button
        type="button"
        class="language"
        @click="$router.push('/language')"
      >
        <img
          :src="require('../images/language/' + lang + '.png')"
          alt=""
        >
      </button>
      <div class="big_tit">
        {{ $t('sky.xuan') }}
      </div>
    </div>

    <van-swipe
      v-if="banner"
      class="banner-swipe"
      :autoplay="3000"
      lazy-render
    >
      <van-swipe-item
        v-for="(item, index) in banner"
        :key="index"
      >
        <img
          :src="item[lang]"
          alt=""
        >
      </van-swipe-item>
    </van-swipe>

    <div class="head-tabs">
      <span
        class="tab-item active"
        @click="cur = 0; resetGirls();"
      >{{ $t('feng.ads') }}</span>
    </div>

    <div class="tab-content">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <van-list
        v-else
        v-model="loading"
        :finished="finished"
        :offset="100"
        :loading-text="$t('pro2.loading')"
        @load="loadGirls"
      >
        <div
          v-if="girls.length"
          class="pblBox"
        >
          <article
            v-for="(item, index) in girls"
            :key="item.id || index"
            class="releaseItem"
            @click="$router.push('/vprofile/' + item.id)"
          >
            <div class="imgBox">
              <img
                :src="formatAssetUrl(item.pic)"
                alt=""
              >
              <span class="corner-ribbon">
                <i>{{ $t('sky.gaoduan') }}</i>
              </span>
              <div class="infoBox">
                <van-icon
                  name="location"
                  class="location-icon"
                />
                <div class="wantyuebtn">
                  {{ $t('sky.yue') }}
                </div>
              </div>
            </div>
            <div class="tagBox">
              <span
                v-for="tag in getGirlTags(item)"
                :key="tag"
                class="tag"
              >
                {{ tag }}
              </span>
            </div>
            <div class="di">
              <div class="name-row">
                <span class="dot" />
                <span>{{ item.name }}</span>
              </div>
              <div class="like-row">
                <van-icon name="like" />
                <span>{{ item.zan }}</span>
              </div>
            </div>
          </article>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
	Swipe,
	SwipeItem,
	Empty,
	List,
	Icon,
} from "vant";
import Fetch from "../../utils/fetch";
import { formatAssetUrl } from "../../utils/assets";
Vue.use(Empty).use(List).use(Icon);

export default {
	name: "Choose",
	components: {
		VanSwipe: Swipe,
		VanSwipeItem: SwipeItem,
	},
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: null,
			loading: false,
			page: 1,
			girls: [],
			banner: null,
			cur: 0,
			area: null,
			arealist: null,
			islogin: false,
			locationsel: false,
			type: 0,
			finished: false,
			empty: false,
			requestLock: false,
		};
	},
	created() {
		this.$parent.footer("girl", true);
	},
	mounted() {
		this.islogin = localStorage.getItem("token") != null;
		if (!this.islogin) {
			this.$router.push("/login");
		}
		this.getBanner();
	},
	methods: {
		formatAssetUrl,
		getBanner() {
			Fetch("/index/int").then(r => {
				this.banner = r.data.banner;
			});
		},
		resetGirls() {
			this.page = 1;
			this.girls = [];
			this.finished = false;
			this.empty = false;
			this.requestLock = false;
			this.loading = true;
			this.loadGirls();
		},
		loadGirls() {
			if (this.requestLock || this.finished) {
				this.loading = false;
				return;
			}
			this.requestLock = true;
			Fetch("/index/girls", {
				page: this.page,
			}).then(r => {
				var rows = r.data && r.data.list ? r.data.list : [];

				for (var i = 0; i < rows.length; i++) {
					rows[i].keys = rows[i].keystr ? rows[i].keystr.split("|") : [];
				}
				if (rows.length > 0) {
					this.girls = this.girls.concat(rows);
					this.page++;
				}
				this.empty = this.girls.length === 0;
				this.finished = !(r.data && r.data.has_more);
				this.loading = false;
				this.requestLock = false;
			}).catch(() => {
				this.loading = false;
				this.requestLock = false;
				this.finished = true;
			});
		},
		getGirlTags(item) {
			return item && item.keys ? item.keys.slice(0, 4).filter(Boolean) : [];
		},
	},
};
</script>

<style lang="less" scoped>
.choose-page {
	--accent: #ff5d7a;
	--accent-strong: #ff4f70;
	--accent-soft: #fff1f5;
	--accent-line: #ffdbe4;
	--text: #16223a;
	--muted: #778195;
	--card-shadow: 0 10px 24px rgba(255, 93, 122, 0.12);
	min-height: 100vh;
	height: 100vh;
	display: flex;
	flex-direction: column;
	background: linear-gradient(180deg, #ff708c 0, #ff879e 198px, #fff8fa 199px, #fff8fa 100%);
	color: var(--text);
	overflow: hidden;
}

.page-top {
	height: 54px;
	flex: 0 0 54px;
	background: transparent;
	color: #fff;
	border: 0;
	box-sizing: border-box;

	.big_tit {
		color: #fff;
		font-size: 16px;
		font-weight: 800;
	}
}

.language {
	position: absolute;
	top: 11px;
	left: 16px;
	width: 30px;
	height: 30px;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 0;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.2);
	box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.22);
}

.language img {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	object-fit: cover;
}

.banner-swipe {
	flex: 0 0 auto;
	margin: 0 16px;
	overflow: hidden;
	border-radius: 16px;
	border: 1px solid rgba(255, 255, 255, 0.55);
	background: #fff0f4;
	box-shadow: 0 12px 24px rgba(181, 43, 72, 0.2);
}

.banner-swipe img {
	display: block;
	width: 100%;
	min-height: 128px;
	object-fit: cover;
}

/deep/ .van-swipe__indicators {
	bottom: 8px;
}

/deep/ .van-swipe__indicator {
	width: 5px;
	height: 5px;
	margin: 0 3px;
	background: rgba(255, 255, 255, 0.68);
}

/deep/ .van-swipe__indicator--active {
	width: 14px;
	border-radius: 8px;
	background: #fff;
}

.head-tabs {
	height: 44px;
	flex: 0 0 44px;
	margin: 14px 16px 0;
	padding: 4px;
	display: flex;
	align-items: center;
	border-radius: 14px;
	border: 1px solid var(--accent-line);
	background: rgba(255, 255, 255, 0.94);
	box-shadow: 0 8px 18px rgba(255, 93, 122, 0.08);
	box-sizing: border-box;
}

.tab-item {
	min-width: 86px;
	height: 34px;
	line-height: 34px;
	border-radius: 10px;
	color: var(--muted);
	font-size: 14px;
	text-align: center;
}

.tab-item.active {
	color: #fff;
	font-weight: 800;
	background: linear-gradient(180deg, #ff7b94 0%, #ff5574 100%);
	box-shadow: 0 6px 12px rgba(255, 85, 116, 0.24);
}

.tab-content {
	flex: 1;
	overflow-y: auto;
	padding-bottom: 94px;
	-webkit-overflow-scrolling: touch;
}

.pblBox {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
	padding: 14px 16px 0;
}

.releaseItem {
	min-width: 0;
	padding: 0 0 11px;
	overflow: hidden;
	border-radius: 15px;
	border: 1px solid var(--accent-line);
	background: #fff;
	box-shadow: var(--card-shadow);
	box-sizing: border-box;
	transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.releaseItem:active {
	transform: scale(0.98);
	box-shadow: 0 5px 13px rgba(255, 93, 122, 0.14);
}

.imgBox {
	position: relative;
	overflow: hidden;
	aspect-ratio: 1 / 1.35;
	background: var(--accent-soft);
}

.imgBox > img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.corner-ribbon {
	position: absolute;
	top: -50px;
	right: -50px;
	z-index: 1;
	width: 90px;
	height: 90px;
	background: linear-gradient(135deg, #ff7892 0%, #ff5574 100%);
	color: #fff;
	transform: rotate(45deg);
}

.corner-ribbon i {
	position: absolute;
	bottom: 7px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 10px;
	font-style: normal;
	font-weight: 700;
	white-space: nowrap;
}

.infoBox {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	height: 46px;
	padding: 0 10px;
	display: flex;
	align-items: center;
	color: #fff;
	background: linear-gradient(180deg, rgba(22, 34, 58, 0) 0%, rgba(22, 34, 58, 0.76) 100%);
	box-sizing: border-box;
}

.location-icon {
	color: #fff;
	font-size: 14px;
}

.wantyuebtn {
	margin-left: auto;
	padding: 5px 8px;
	border-radius: 8px;
	border: 1px solid rgba(255, 255, 255, 0.76);
	background: rgba(255, 93, 122, 0.88);
	color: #fff;
	font-size: 10px;
	font-weight: 700;
}

.tagBox {
	min-height: 30px;
	padding: 10px 10px 0;
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
}

.tag {
	max-width: 100%;
	padding: 4px 8px;
	border-radius: 8px;
	background: var(--accent-soft);
	color: var(--accent);
	font-size: 10px;
	line-height: 16px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.di {
	padding: 9px 10px 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: var(--muted);
	font-size: 12px;
	line-height: 18px;
}

.name-row,
.like-row {
	min-width: 0;
	display: flex;
	align-items: center;
}

.name-row span:last-child {
	min-width: 0;
	color: var(--text);
	font-weight: 800;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.dot {
	width: 9px;
	height: 9px;
	flex: 0 0 9px;
	margin-right: 5px;
	border-radius: 50%;
	background: var(--accent);
	box-shadow: 0 0 0 3px var(--accent-soft);
}

.like-row {
	flex: 0 0 auto;
	margin-left: 8px;
	color: var(--accent);
}

.like-row span {
	margin-left: 3px;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description,
/deep/ .van-list__loading,
/deep/ .van-list__finished-text {
	color: var(--muted);
}

@media screen and (max-width: 374px) {
	.banner-swipe,
	.head-tabs {
		margin-right: 12px;
		margin-left: 12px;
	}

	.pblBox {
		gap: 10px;
		padding-right: 12px;
		padding-left: 12px;
	}
}
</style>
